module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"video_upload_error":{"default":"视频上传失败。","too_large":"视频最大可上传500MB。","invalid_type":"文件格式非视频。"},"video_create_error":{"default":"视频上传过程中发生错误。"}}}')
  delete Component.options._Ctor
}
